import React, { Fragment, useState, useEffect } from 'react';
import { useFormik } from 'formik';

import { Gridfield, Textfield } from 'components/Form';
import ModalForm from 'components/Modal/Modal';

import { HomeSchema, useAccounts } from 'features/home';

const initialValues = {
  name: ``,
  email: ``,
};

const ModalDataComponent = ({ title, isOpen, onClose }) => {
  const [initFormik, setInitFormik] = useState(initialValues);

  const { addDispatchAccount, setFetchingAccounts } = useAccounts();

  useEffect(() => {
    setInitFormik(initialValues);
  }, []);

  const createAccountFetcher = (payload) => {
    addDispatchAccount(payload)
      .then(() => setFetchingAccounts(true))
      .catch((error) => console.log(error));
  };

  const { values, handleChange, handleSubmit, touched, errors, resetForm } =
    useFormik({
      initialValues: initFormik,
      validationSchema: HomeSchema,
      enableReinitialize: true,
      onSubmit: (values) => {
        createAccountFetcher(values);
        closeModal();
      },
    });

  function closeModal() {
    onClose();
    resetForm();
  }

  const renderModalFields = (
    <Fragment>
      <Gridfield label="Name">
        <Textfield
          name="name"
          placeholder="name"
          value={values.name}
          onChange={handleChange}
          error={Boolean(errors.name && touched.name)}
          helperText={touched.name && errors.name}
        />
      </Gridfield>
      <Gridfield label="Email">
        <Textfield
          name="email"
          placeholder="email"
          value={values.email}
          onChange={handleChange}
          error={Boolean(errors.email && touched.email)}
          helperText={touched.email && errors.email}
        />
      </Gridfield>
    </Fragment>
  );

  return (
    <ModalForm
      title={title}
      isOpen={isOpen}
      onClose={closeModal}
      onSubmit={handleSubmit}
    >
      {renderModalFields}
    </ModalForm>
  );
};

const ModalData = React.memo(ModalDataComponent);
export default ModalData;
